import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="0" y="15" rx="4" ry="4" width="290" height="7" />
      <rect x="0" y="35" rx="3" ry="3" width="250" height="7" />
    </React.Fragment>
  );
};
